export function slugifyProductPart(value) {
  return (value || 'product')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80) || 'product';
}

export function productSlug(product) {
  const name = slugifyProductPart([product.brand, product.name].filter(Boolean).join(' '));
  return `${name}-${product.id}`;
}

export function productPath(product) {
  return `/products/${productSlug(product)}`;
}

export function productIdFromSlug(slug) {
  const match = (slug || '').match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i);
  return match ? match[0] : null;
}
